export const arrayToCSV = (array: any[]): string => {
  if (array.length === 0) return '';

  const escapeCell = (v: any) => {
    const s = String(v ?? '');
    return s.includes(',') || s.includes('"') || s.includes('\n')
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };
  const keys: string[] = Object.keys(array[0]);
  const data = [keys.map(escapeCell), ...array.map(row => keys.map(k => escapeCell(row[k])))];
  return data.map(row => row.join(',')).join('\n');
};
